export const checkUser = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/authenticate-user`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        if (!response.ok) {
            console.error(`Error: ${response.status} ${response.statusText}`);
            return false;
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Fetch error:', error);
        return false;
    }
};

export const loginUser = async (email, password) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, password }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export const register = async (key, password) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ key, password }),
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error registering:", error);
        throw error;
    }
};

export const sendPasswordResetEmail = async (email) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/send-password-reset-email`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email }),
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error sending password reset email:", error);
        throw error;
    }
};

export const resetPassword = async (token, newPassword) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/reset-password`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token, newPassword }),
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error resetting password:", error);
        throw error;
    }
};

export const getUsers = async (page, lastUsedSortDirection) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/${page}/${lastUsedSortDirection}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const getSingleHistory = async (sessionId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/history/${sessionId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching single history:", error);
        throw error;
    }
};

export const addUser = async (name, email, role) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/add-user`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name,
                email,
                role,
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error adding user:", error);
        throw error;
    }
};

export const getHistory = async (page, filter) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/all-history/${page}/${filter}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching history:", error);
        throw error;
    }
};

export const getStatistics = async (filter) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/statistics/${filter}/${new Date().getTimezoneOffset() / -60}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching statistics:", error);
        throw error;
    }
};

export const getFeedback = async (page, filter) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/all-feedback/${page}/${filter}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching feedback:", error);
        throw error;
    }
};

export const getBotInformation = async (page) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot/${page}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching bot information:", error);
        throw error;
    }
};

export const getSingleFeedback = async (Id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/feedback/${Id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching single feedback:", error);
        throw error;
    }
};

export const getHelpRequests = async (page, filter) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/all-help-requests/${page}/${filter}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching help requests:", error);
        throw error;
    }
};

export const getSingleHelpRequest = async (Id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/help-requests/${Id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching single help request:", error);
        throw error;
    }
};

export const changeHelpRequestStatus = async (id, change) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/help-requests/${change}/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error changing help request status:", error);
        throw error;
    }
};

export const getHelpRequestsCount = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/all-help-requests-count`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });
    
        const data = await response.json();
    
        return data;
    } catch (error) {
        console.error('Fetch error:', error);
        return false;
    }
};

export const logoutUser = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logout`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error logging out:", error);
        throw error;
    }
};

export const getUser = async id => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching user:", error);
        throw error;
    }
};

export const changePassword = async (oldPassword, newPassword) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/change-password`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                oldPassword,
                newPassword
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error changing password:", error);
        throw error;
    }
};

export const deleteUser = async id => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/${id}/delete`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
    }
};

export const changeTheme = async (id, theme) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/change-theme`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id,
                theme
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error changing theme:", error);
        throw error;
    }
};

export const addBotInfo = async content => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                content,
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error adding bot info:", error);
        throw error;
    }
};

export const editBotInfo = async ({ id, content, type }) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot/edit/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                content,
                type,
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error editing bot info:", error);
        throw error;
    }
};

export const deleteBotInfo = async infoId => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot/delete/${infoId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error deleting bot info:", error);
        throw error;
    }
};

export const uploadFile = async (files, pdfURLs, updateProgress, onFail) => {
    const formData = new FormData();

    let fileProgress = files.length + pdfURLs.length;

    pdfURLs = pdfURLs.filter(item => item.file.path);

    formData.append('capability', 'upload_document');
    formData.append('filesData', JSON.stringify([...files, ...pdfURLs]));

    for (let i = 0; i < files.length; i++) {
        try {
            formData.append('files', files[i].file, files[i].file.name);
            updateProgress(50 / fileProgress);
        } catch (error) {
            onFail(true);
            updateProgress(100);
            throw new Error(error);
        }

        fileProgress--;
    }

    for (let i = 0; i < pdfURLs.length; i++) {
        try {
            const response = await fetch(pdfURLs[i].source_url);
            const blob = await response.blob();
            const urlParts = pdfURLs[i].source_url.split('/');
            const filename = urlParts[urlParts.length - 1];
            const file = new File([blob], filename, { type: blob.type, lastModified: blob.lastModified });
            formData.append('files', file, filename);
            updateProgress(50 / fileProgress);
        } catch (error) {
            onFail(true);
            updateProgress(100);
            throw new Error(error);
        }

        fileProgress--;
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/upload-files`, {
            method: 'POST',
            body: formData,
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        onFail(true);
        updateProgress(100);
        throw new Error(error);
    }
};

export const registerFile = async (filesData, updateProgress, onFail) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register-files`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                filesData
            }),
            credentials: "include",
        });

        const data = await response.json();

        updateProgress(100);

        return data;
    } catch (error) {
        onFail(true);
        updateProgress(100);
        throw new Error(error);
    }
};

export const getDocuments = async page => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/documents/${page}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching documents:", error);
        throw error;
    }
};

export const deleteDocument = async fileId => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/documents/${fileId}/delete`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error deleting document:", error);
        throw error;
    }
};

export const updateDocument = async (file_id, title, source_url) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/documents/${file_id}/update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                title,
                source_url,
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error updating document:", error);
        throw error;
    }
};

export const updateBotSettings = async (settings) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/bot-settings`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                settings,
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error updating bot settings:", error);
        throw error;
    }
};

export const getBotSettings = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/bot-settings`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching bot settings:", error);
        throw error;
    }
};

export const getSearchResults = async (search, limit, page) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/search`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                search,
                limit: limit || undefined,
                page: page || undefined,
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching search results:", error);
        throw error;
    }
};

export const saveNewFunFacts = async funFacts => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/fun-facts/new`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                funFacts
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error saving new fun facts:", error);
        throw error;
    }
};

export const getFunFacts = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/fun-facts`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching fun facts:", error);
        throw error;
    }
};

export const updateFunFact = async funFact => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/fun-facts/edit/${funFact.id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                funFact
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error updating fun fact:", error);
        throw error;
    }
};

export const deleteFunFact = async id => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/fun-facts/delete/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error deleting fun fact:", error);
        throw error;
    }
};

export const approveBotInfo = async (id, content) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot/approve/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                content,
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error approving bot info:", error);
        throw error;
    }
};

export const findBestMatchSearchResult = async (query, results) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/search/rerank`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                query,
                results: results.filter(result => result !== null),
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error finding best match search result:", error);
        throw error;
    }
};

export const verifyCode = async (email, code) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/verify-email-code`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, code }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error verifying code:", error);
        throw error;
    }
};

export const sendVerificationCode = async (email, code) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/verify-email-code`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, code }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error sending verification code:", error);
        throw error;
    }
};

export const serverUrl = process.env.REACT_APP_API_URL;

export const getChatHistory = async sessionId => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/chat-history/${sessionId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching chat history:", error);
        throw error;
    }
};

export const getThinkingLogs = async sessionId => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/thinking-logs/${sessionId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching thinking logs:", error);
        throw error;
    }
};

export const getVerificationCode = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/verification-code`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching verification code:", error);
        throw error;
    }
};

export const getDocumentRetrievalQuestionSuggestions = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/document_retrieval/question-suggestions`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching questions suggestions:", error);
        throw error;
    }
};

export const updateUserLatestReleaseVersion = async release => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/update-latest-viewed-release`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ release }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export const getUserLatestViewedRelease = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/get-latest-viewed-release`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching questions suggestions:", error);
        throw error;
    }
};

export const getDocumentFilenames = async page => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/documents`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching documents:", error);
        throw error;
    }
};

export const submitFeedbackComment = async (feedback_id, comment) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/feedback/comment`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                feedback_id,
                comment
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export const getFeedbackComments = async feedback_id => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/feedback/${feedback_id}/comments`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export const pinThread = async (sessionId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/history/toggle-pin`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                sessionId,
            }),
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const parseOrderPdf = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/parse-pdf`, {
            method: "POST",
            credentials: "include",
            body: formData,
        });

        const data = await response.json();

        if (!response.ok) {
            return { success: false, error: data };
        }

        return { success: true, data };
    } catch (error) {
        console.error("Error parsing order PDF:", error);
        return { success: false, error };
    }
};

export const saveOrderSubmission = async (file, order, status, deacomSoNumber) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('order', JSON.stringify(order));
    formData.append('status', status);
    formData.append('deacomSoNumber', deacomSoNumber || '');

    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/submissions`, {
            method: "POST",
            credentials: "include",
            body: formData,
        });

        const data = await response.json();

        if (!response.ok) {
            return { success: false, error: data };
        }

        return { success: true, data };
    } catch (error) {
        console.error("Error saving order submission:", error);
        return { success: false, error };
    }
};

export const getOrderSubmissions = async (page, sortBy, sortDir, search) => {
    try {
        const params = new URLSearchParams();
        if (page) params.set('page', page);
        if (sortBy) params.set('sortBy', sortBy);
        if (sortDir) params.set('sortDir', sortDir);
        if (search) params.set('search', search);
        const query = params.toString();

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/submissions${query ? `?${query}` : ''}`, {
            method: "GET",
            credentials: "include",
        });

        const data = await response.json();

        if (!response.ok) {
            return { success: false, error: data };
        }

        return { success: true, data };
    } catch (error) {
        console.error("Error fetching order submissions:", error);
        return { success: false, error };
    }
};

export const getOrderSubmission = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/submissions/${id}`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error fetching order submission:", error);
        return { success: false, error };
    }
};

export const updateOrderSubmission = async (id, order, status, deacomSoNumber) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/submissions/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ order, status, deacomSoNumber }),
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error updating order submission:", error);
        return { success: false, error };
    }
};

export const getDeacomConfirmations = async page => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/deacom-confirmations/${page}`, {
            method: "GET",
            credentials: "include",
        });

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching Deacom confirmations:", error);
        return { success: false, error };
    }
};

export const updateSubmissionStatus = async (id, status) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/submissions/${id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ status }),
        });

        const data = await response.json();

        if (!response.ok) {
            return { success: false, error: data };
        }

        return { success: true, data };
    } catch (error) {
        console.error("Error updating submission status:", error);
        return { success: false, error };
    }
};

export const searchDeacomCustomers = async (q) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deacom/customers/search?q=${encodeURIComponent(q)}`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error searching Deacom customers:", error);
        return { success: false, error };
    }
};

export const searchDeacomShipTos = async (q, billToId) => {
    try {
        const params = new URLSearchParams({ q: q || '' });
        if (billToId) params.set('billToId', billToId);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deacom/shiptos/search?${params.toString()}`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error searching Deacom ship-tos:", error);
        return { success: false, error };
    }
};

export const searchDeacomSkus = async (q) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deacom/skus/search?q=${encodeURIComponent(q)}`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error searching Deacom SKUs:", error);
        return { success: false, error };
    }
};

export const downloadOrderEdi = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/submissions/${id}/edi`, {
            method: "GET",
            credentials: "include",
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            return { success: false, error };
        }

        const blob = await response.blob();
        const disposition = response.headers.get('Content-Disposition') || '';
        const match = disposition.match(/filename="?([^"]+)"?/);
        const filename = match ? match[1] : `order-${id}_Order_Conf.txt`;

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);

        return { success: true };
    } catch (error) {
        console.error("Error downloading EDI file:", error);
        return { success: false, error };
    }
};

export const getOrderSubmissionPdfBlob = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/orders/submissions/${id}/pdf-file`, {
            method: "GET",
            credentials: "include",
        });
        if (!response.ok) return { success: false, error: await response.json().catch(() => ({})) };
        return { success: true, data: await response.blob() };
    } catch (error) {
        console.error("Error fetching order submission PDF:", error);
        return { success: false, error };
    }
};

export const getDeacomBillTo = async (billToId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deacom/billtos/${encodeURIComponent(billToId)}`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error fetching Deacom bill-to:", error);
        return { success: false, error };
    }
};

export const getDeacomShipVias = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deacom/shipvias`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error fetching Deacom ship-vias:", error);
        return { success: false, error };
    }
};

export const getDeacomTerms = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deacom/terms`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error fetching Deacom terms:", error);
        return { success: false, error };
    }
};

export const getItemMasterLastUpdated = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deacom/item-master/last-updated`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) return { success: false, error: data };
        return { success: true, data };
    } catch (error) {
        console.error("Error fetching item master status:", error);
        return { success: false, error };
    }
};